// Judge.me reviews - profile picture logic
var WDN = WDN || {};

if (typeof WDN.ProductPageReviews === "undefined") {
  WDN.ProductPageReviews = (function () {
    // Private functions
    var init, generateProfilePicture;

    // Listeners
    var listenForReviewLoad, listenForLayoutUpdate;

    // Handlers
    var handleMutationObserver, handleLayoutUpdate;

    // Nodes
    var wrapperContainer = document.querySelector(".jdgm-review-widget");

    // Helper function for generating profile pictures
    generateProfilePicture = function () {
      var authors = document.querySelectorAll(".jdgm-rev__author");

      authors.forEach(function (author) {
        var profileHeader = author.closest(".jdgm-rev__header");
        var firstLetter = author.innerText.slice(0, 1).toUpperCase();
        var icon = profileHeader.querySelector(".jdgm-rev__icon");

        icon.style = "--author-letter:'" + firstLetter + "'";
      });
    };

    // Fired when interacting with sorting/pagination
    handleLayoutUpdate = function () {
      generateProfilePicture();
    };

    // Mutation observer: listens for pagination/sorting, fires handleLayoutUpdate as callback
    listenForLayoutUpdate = function () {
      var reviewBody = wrapperContainer.querySelector(".jdgm-rev-widg__body");
      if (!reviewBody) return;
      var timer;

      var observer = new MutationObserver(function () {
        clearTimeout(timer);

        timer = setTimeout(function () {
          handleLayoutUpdate();
        }, 300);
      });
      observer.observe(reviewBody, { attributes: true, childList: false, subtree: false });
    };

    // Mutation observer: listens for widget load, fires init as callback
    listenForReviewLoad = function () {
      // If widget loaded - init
      if (wrapperContainer.classList.contains("jdgm--done-setup-widget")) {
        init();
        return;
      }

      // Otherwise set up mutation observer and listend for load
      handleMutationObserver = function (mutationList) {
        if (mutationList[0].target.classList.contains("jdgm--done-setup-widget")) {
          observer.disconnect();
          init();
        }
      };
      var observer = new MutationObserver(handleMutationObserver);
      observer.observe(wrapperContainer, { attributes: true, childList: false, subtree: false });
    };

    // Init function, fires when widget is loaded
    init = function () {
      generateProfilePicture();
      listenForLayoutUpdate();
    };

    // Code starts here
    if (wrapperContainer) {
      listenForReviewLoad();
    }

    return {};
  })();
}
